import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=b0b9cab6&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"
import "./AppHeader.vue?vue&type=style&index=0&id=b0b9cab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b9cab6",
  null
  
)

export default component.exports